module.exports = __webpack_public_path__ + "media/images/flags/1x1/hkg-6fcfcf62746e31383a5143bff31b57cc.svg";